import { render, staticRenderFns } from "./DialogAtivarNumero.vue?vue&type=template&id=10c7dd9a"
import script from "./DialogAtivarNumero.vue?vue&type=script&lang=js"
export * from "./DialogAtivarNumero.vue?vue&type=script&lang=js"
import style0 from "./DialogAtivarNumero.vue?vue&type=style&index=0&id=10c7dd9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports